import gsap from 'gsap';
import { hexToHsl } from './utils';

const BASE_ANGLE = 135;
const BASE_ANGLE_STAMP = 45;

class PenToolCursor {
    constructor(canvasContainer) {
        this.canvasContainer = canvasContainer;
        this.handlers = {
            enter: this.enter.bind(this),
            leave: this.leave.bind(this),
        }
        this.activeMode = 'brush';
        this.x = 0;
        this.y = 0;
        this.lastX = 0;
        this.lastY = 0;
        this.lastTime = 0;
        this.isShown = false;
        this.elements = {
            brush: document.getElementById("tool"),
            stamp: document.getElementById("tool-stamp"),
        };
        this.toolStampSvgElement1 = this.elements.stamp.querySelector('.tool-colored1');
        this.toolStampSvgElement2 = this.elements.stamp.querySelector('.tool-colored2');
        this.coloredPaths = {
            brush: [
                this.elements.brush.querySelector(".tool-colored1"),
                this.elements.brush.querySelector(".tool-colored2"),
            ],
            stamp: [
                this.elements.stamp.querySelector(".tool-colored1"),
                this.elements.stamp.querySelector(".tool-colored2"),
            ],
        };
        gsap.set(this.elements.brush, { scale: 1, rotate: BASE_ANGLE });
        gsap.set(this.elements.stamp, { scale: 1, rotate: BASE_ANGLE_STAMP });

        this.canvasContainer.addEventListener("mouseenter", this.handlers.enter);
        this.canvasContainer.addEventListener("mouseleave", this.handlers.leave);
    }

    up() {
        if (this.activeMode == "stamp") {
            gsap.to(this.toolStampSvgElement1, { duration: 0.27, x: 0, y: 0, rotation: 0, ease: 'circ.out' });
            gsap.to(this.toolStampSvgElement2, { duration: 0.26, x: 0, y: 0, rotation: 0, ease: 'circ.out' });
        }
    }

    down() {
        if (this.activeMode == "stamp") {
            gsap.to(this.toolStampSvgElement1, { duration: 0.11, x: -3, y: 12, rotation: -6, ease: 'circ.out' });
            gsap.to(this.toolStampSvgElement2, { duration: 0.12, x: -6, y: 12, rotation: -7, ease: 'circ.out' });
        }
    }

    changeMode(mode) {
        this.activeMode = mode;
        // hide the other element
        if (mode == 'brush') {
            gsap.to(this.elements['stamp'], { duration: 0.2, scale: 0, ease: 'circ.out' });
            gsap.to(this.elements['brush'], { duration: 0.2, scale: 1, ease: 'circ.out' });
        } else {
            gsap.to(this.elements['brush'], { duration: 0.2, scale: 0, ease: 'circ.out' });
            gsap.to(this.elements['stamp'], { duration: 0.2, scale: 1, ease: 'circ.out' });
        }
    }

    dispose() {
        this.isShown = false;
        this.hideElement();
        this.canvasContainer.removeEventListener("mouseenter", this.handlers.enter);
        this.canvasContainer.removeEventListener("mouseleave", this.handlers.leave);
    }

    enter() {
        if (this.isShown) {
            this.showElement();
        }
    }

    leave() {
        this.hideElement();
    }

    changeColor(color) {
        this.coloredPaths[this.activeMode][0].style.fill = color;
        const hsl = hexToHsl(color);
        this.coloredPaths[this.activeMode][1].style.fill = 'hsl(' + hsl[0] + ',' + hsl[1] * 100 + '%,' + Math.max(0, hsl[2] * 100 - 10) + '%)';
    }

    update(timestamp, x, y) {
        /*const deltaTime = timestamp - this.lastTime;
        this.x = x;
        this.y = y;
        const distanceX = this.x - this.lastX;
        const distanceY = this.y - this.lastY;
        const maxDist = Math.abs(distanceX) > Math.abs(distanceY) ? distanceX : distanceY;
        const directionSpeed = maxDist / deltaTime;
        const duration = Math.min(4, Math.max(0.3, 1 / Math.max(0.2, Math.abs(directionSpeed))));
        */
        if (this.isShown) {
            gsap.set(this.elements[this.activeMode], { x: x, y: y });
        }
        /*gsap.to(this.element, { duration: duration, rotation: BASE_ANGLE - directionSpeed * 10 });
        this.lastX = this.x;
        this.lastY = this.y;
        this.lastTime = timestamp;*/
    }

    showElement() {
        this.elements[this.activeMode].classList.add("shown");
        this.canvasContainer.style.cursor = "none";
        gsap.to(this.elements[this.activeMode], { duration: 0.4, scale: 1, ease: "back.out" });

    }

    hideElement() {
        this.canvasContainer.style.cursor = 'auto';
        gsap.to(this.elements[this.activeMode], { duration: 0.2, scale: 0, ease: 'circ.out' });
    }

    show() {
        this.isShown = true;
        this.showElement();
    }

    hide() {
        this.isShown = false;
        this.hideElement();
        this.elements[this.activeMode].classList.remove('shown');
    }
}

export { PenToolCursor };